// API bindings: notifications (Auto generated)

"use strict";

import { RequestErrorHandler, RequestParams, CommonAuthenticatedErrorHandler } from "@asanrom/request-browser";
import { getApiUrl, generateURIQuery } from "./utils";
import { NotificationList, UnreadNotificationsResponse } from "./definitions";

export class ApiNotifications {
    /**
     * Method: GET
     * Path: /notifications
     * Lists notifications
     * @param queryParams Query parameters
     * @returns The request parameters
     */
    public static ListNotifications(queryParams: ListNotificationsQueryParameters): RequestParams<NotificationList, CommonAuthenticatedErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/notifications` + generateURIQuery(queryParams)),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: DELETE
     * Path: /notifications
     * Deletes all notifications
     * @returns The request parameters
     */
    public static DeleteAllNotifications(): RequestParams<void, CommonAuthenticatedErrorHandler> {
        return {
            method: "DELETE",
            url: getApiUrl(`/notifications`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: DELETE
     * Path: /notifications/{id}
     * Deletes notification
     * @param id Notification ID
     * @returns The request parameters
     */
    public static DeleteNotification(id: string): RequestParams<void, DeleteNotificationErrorHandler> {
        return {
            method: "DELETE",
            url: getApiUrl(`/notifications/${encodeURIComponent(id)}`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /notifications/{id}/mark-read
     * Mark notification as read
     * @param id Notification ID
     * @returns The request parameters
     */
    public static ReadNotification(id: string): RequestParams<void, ReadNotificationErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/notifications/${encodeURIComponent(id)}/mark-read`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /notifications/read
     * Mark all notifications as read
     * @returns The request parameters
     */
    public static ReadAllNotifications(): RequestParams<void, CommonAuthenticatedErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/notifications/read`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /notifications/unread
     * Find unread notifications
     * @returns The request parameters
     */
    public static GetUnreadNotifications(): RequestParams<UnreadNotificationsResponse, CommonAuthenticatedErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/notifications/unread`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }
}

/**
 * Query parameters for ListNotifications
 */
export interface ListNotificationsQueryParameters {
    /**
     * Page. Starting by 1.
     */
    page?: number;
}

/**
 * Error handler for DeleteNotification
 */
export type DeleteNotificationErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for ReadNotification
 */
export type ReadNotificationErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

